export function base64FileSize(base64: string): number {
  // https://softwareengineering.stackexchange.com/questions/288670/know-file-size-with-a-base64-string
  return base64.length * (3 / 4) - (base64.endsWith("==") ? 2 : 1);
}
